import React, { useState } from "react";
import classNames from "classnames";
import { useTranslate } from "../../translate";
import Search from "./Search";

function ItineraryMetadata(props) {
    const {
        routeLogo,
        itineraryImg,
        routeName,
        itineraryName,
        itineraryType,
        days,
        distance,
        stopsCount,
        itineraryDescription,
        setLoopDirection,
        setStartingPoint,
        className,
        showLoopDirections,
        hideStartingPointField,
        loopDirection,
        children,
        withTopSpacing,
    } = props;
    const translate = useTranslate();
    const [isLogoVertical, setIsLogoVertical] = useState(false);
    const [hasImgLoaded, setHasImgLoaded] = useState(false);
    const [hasLogoLoaded, setHasLogoLoaded] = useState(false);
    const onLogoLoad = event => {
        setHasLogoLoaded(true);
        if (event.target.naturalHeight > event.target.naturalWidth) {
            setIsLogoVertical(true);
        }
    };
    const onImgLoad = () => setHasImgLoaded(true);

    return (
        <div
            className={classNames("trpr-itinerary-metadata", className, {
                "with-top-spacing": withTopSpacing,
                "js-itinerary-metadata-ready": hasImgLoaded,
            })}
        >
            {children}
            <div
                className={classNames("trpr-itinerary-metadata__secondary-bg", {
                    "has-vertical-route-logo": isLogoVertical,
                    "has-route-logo": routeLogo,
                    "has-loaded": !itineraryImg || hasImgLoaded,
                })}
            ></div>
            <div className="trpr-itinerary-metadata__wrapper">
                <div
                    className={classNames("trpr-itinerary-metadata__hero", {
                        "has-loaded": !itineraryImg || hasImgLoaded,
                    })}
                >
                    {routeLogo && (
                        <div
                            className={classNames("trpr-itinerary-metadata__route-logo-container", {
                                "has-loaded": hasLogoLoaded,
                            })}
                        >
                            <img
                                onLoad={onLogoLoad}
                                src={routeLogo}
                                alt={itineraryName}
                                className={classNames("trpr-itinerary-metadata__route-logo", {
                                    "is-vertical": isLogoVertical,
                                })}
                            />
                        </div>
                    )}
                    <img
                        onLoad={onImgLoad}
                        src={itineraryImg}
                        alt={routeName}
                        className={classNames("trpr-itinerary-metadata__itinerary-img", {
                            "has-loaded": hasImgLoaded,
                        })}
                    />
                </div>
                <div className="trpr-itinerary-metadata__info">
                    <div className="trpr-itinerary-metadata__info-header">
                        <h2 className="trpr-itinerary-metadata__route-name">{routeName}</h2>
                        <h1 className="trpr-itinerary-metadata__itinerary-name">{itineraryName}</h1>
                    </div>
                    <div className="trpr-itinerary-metadata__info-body">
                        <div className="trpr-itinerary-metadata__itinerary-type">{itineraryType}</div>
                        <ul className="trpr-itinerary-metadata__itinerary-info">
                            <li>
                                <i className="trpr__icon-time"></i>
                                <span>
                                    {days} {days > 1 ? translate("days") : translate("day")}
                                </span>
                            </li>
                            <li>
                                <i className="trpr__icon-road"></i>
                                <span>{distance} km</span>
                            </li>
                            <li>
                                <i className="trpr__icon-marker"></i>
                                <span>
                                    {stopsCount} {translate("stops")}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className={classNames("trpr-itinerary-metadata__itinerary-description", {
                        "without-margin-bottom": hideStartingPointField && !showLoopDirections,
                    })}
                    dangerouslySetInnerHTML={{ __html: itineraryDescription }}
                ></div>
                {(!hideStartingPointField || showLoopDirections) && (
                    <div
                        className={classNames("trpr-itinerary-metadata__footer trpr__hide-in-pdf-mode", {
                            "without-starting-point-field": hideStartingPointField,
                        })}
                    >
                        <div className="trpr-itinerary-metadata__form">
                            {!hideStartingPointField && (
                                <>
                                    <span className="trpr-itinerary-metadata__label">
                                        {translate("Where are you coming from?")}
                                    </span>
                                    <Search
                                        className="trpr-itinerary-metadata__where-input"
                                        setStartingPoint={setStartingPoint}
                                    ></Search>
                                </>
                            )}
                        </div>
                        <div className="trpr-itinerary-metadata__loop-direction-container">
                            {showLoopDirections && (
                                <>
                                    <span className="trpr-itinerary-metadata__label">
                                        {translate("Loop direction")}
                                    </span>
                                    <div className="trpr-itinerary-metadata__loop-direction-container-wrapper">
                                        <button
                                            type="button"
                                            className={classNames("trpr-itinerary-metadata__clockwise-btn", {
                                                "is-active": loopDirection === "CLOCKWISE",
                                            })}
                                            onClick={() => setLoopDirection("CLOCKWISE")}
                                        >
                                            <i className="trpr__icon-cw"></i>
                                            <span>{translate("Clockwise")}</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={classNames("trpr-itinerary-metadata__counter-clockwise-btn", {
                                                "is-active": loopDirection === "COUNTER_CLOCKWISE",
                                            })}
                                            onClick={() => setLoopDirection("COUNTER_CLOCKWISE")}
                                        >
                                            <i className="trpr__icon-cw"></i>
                                            <span>{translate("Counter-clockwise")}</span>
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

ItineraryMetadata.defaultProps = {
    withTopSpacing: true,
};

export default ItineraryMetadata;
